import EventDetails from "./EventDetails";
import ReservationForm from "./ReservationForm";
import { Phone } from "lucide-react";

export default function Reservation() {
  return (
    <section
      id="reservation"
      data-testid="reservation-section"
      className="px-6 md:px-12 lg:px-20 py-14 md:py-20 bg-white min-h-screen"
    >
      <header className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
        <p
          data-testid="brand-mark"
          className="text-xs uppercase tracking-[0.28em] text-[var(--accent)] font-medium mb-3"
        >
          Douceur &amp; Bienfait
        </p>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[var(--text-primary)]">
          Réservez votre <span className="italic">animation</span>
        </h1>
        <p className="mt-5 text-base sm:text-lg text-[var(--text-secondary)] leading-relaxed">
          Découvrez l'atelier à l'affiche et réservez votre place en quelques
          secondes — nous vous recontactons rapidement pour confirmer.
        </p>
      </header>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-8">
        <div className="lg:col-span-2">
          <EventDetails />
        </div>
        <div className="lg:col-span-3">
          <ReservationForm />
        </div>
      </div>

      <div
        data-testid="support-block"
        className="max-w-6xl mx-auto mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 px-6 py-5 border border-dashed border-[var(--line)] rounded-2xl"
      >
        <p className="text-sm text-[var(--text-secondary)] leading-relaxed">
          Une question, une demande particulière, ou un autre type d'animation ?
          Contactez-nous directement, nous serons ravis d'échanger avec vous.
        </p>
        <a
          href="tel:+33647883157"
          data-testid="support-phone"
          className="shrink-0 inline-flex items-center gap-2 text-[var(--text-primary)] hover:text-[var(--accent)] transition-colors"
        >
          <Phone size={16} />
          <span className="font-serif text-xl tracking-wide">
            06.47.88.31.57
          </span>
        </a>
      </div>
    </section>
  );
}
